import * as IDs from '../enums/share-link-IDs'

export default {
  /**
   * Method checks the shareId against list of ShareId's used for auto downloads.
   * @param shareID
   * @param noteBookShare
   * @returns {boolean | *}
   */
  resolve(shareID, noteBookShare) {
    let result = IDs.NOTEBOOK_SHARELINK_ID.includes(shareID)
    return result && noteBookShare
  }
}
